/**
 * CaptureProgress - Progress indicator for bug/feature submission
 */
import React from 'react';
import './BugReporter.css';

const SENT = 'Sent. We have your report.';

const BUG_STEPS = [
  { id: 'screenshot', label: 'Capturing screenshot...' },
  { id: 'submitting', label: 'Submitting report...' },
  { id: 'complete', label: SENT }
];

const FEATURE_STEPS = [
  { id: 'submitting', label: 'Submitting request...' },
  { id: 'complete', label: SENT }
];

function CaptureProgress({ currentStep, error, isFeatureRequest = false }) {
  const STEPS = isFeatureRequest ? FEATURE_STEPS : BUG_STEPS;
  const currentIndex = STEPS.findIndex(s => s.id === currentStep);

  if (error) {
    return (
      <div className="capture-progress capture-progress--error">
        <span className="capture-progress__icon">❌</span>
        <span className="capture-progress__text">{error}</span>
      </div>
    );
  }

  if (currentStep === 'complete') {
    return (
      <div className="capture-progress capture-progress--complete">
        <span className="capture-progress__icon">✅</span>
        <span className="capture-progress__text">{SENT}</span>
      </div>
    );
  }

  const step = STEPS[currentIndex] || STEPS[0];

  return (
    <div className="capture-progress">
      <span className="capture-progress__spinner"></span>
      <span className="capture-progress__text">{step.label}</span>
    </div>
  );
}

export default CaptureProgress;
